// src/useHistory.js
import { useReducer, useCallback } from 'react'

// 1. Definisikan reducer
const historyReducer = (state: any, action: any) => {
  const { past, present, future } = state

  switch (action.type) {
    case 'UNDO': {
      if (past.length === 0) return state // Tidak ada yang bisa di-undo

      const previous = past[past.length - 1]
      const newPast = past.slice(0, past.length - 1)

      return {
        past: newPast,
        present: previous,
        future: [present, ...future],
      }
    }
    case 'REDO': {
      if (future.length === 0) return state // Tidak ada yang bisa di-redo

      const next = future[0]
      const newFuture = future.slice(1)

      return {
        past: [...past, present],
        present: next,
        future: newFuture,
      }
    }
    case 'SET': {
      // Dapatkan state baru dari action
      const { newPresent: actionValue } = action

      // Cek apakah actionValue adalah fungsi. Jika ya, panggil dengan state 'present' saat ini.
      const newPresent = typeof actionValue === 'function' ? actionValue(present) : actionValue

      // Jika tidak ada perubahan, jangan lakukan apa-apa
      if (newPresent === present) {
        return state
      }

      return {
        past: [...past, present],
        present: newPresent,
        future: [],
      }
    }
    case 'RESET':
      return {
        past: [],
        present: action.newPresent, // Langsung set state baru
        future: [],
      }
    default: {
      return state
    }
  }
}

// 2. Buat custom hook
export const useHistory = (initialPresent: any) => {
  const [state, dispatch] = useReducer(historyReducer, {
    past: [],
    present: initialPresent,
    future: [],
  })

  const canUndo = state.past.length > 0
  const canRedo = state.future.length > 0

  // 3. Bungkus fungsi dispatch agar lebih mudah digunakan
  const undo = useCallback(() => {
    dispatch({ type: 'UNDO' })
  }, [])

  const redo = useCallback(() => {
    dispatch({ type: 'REDO' })
  }, [])

  const set = useCallback((actionValue: any) => {
    // Pastikan nama propertinya `newPresent`
    dispatch({ type: 'SET', newPresent: actionValue })
  }, [])

  const reset = useCallback((newPresent: any) => {
    dispatch({ type: 'RESET', newPresent })
  }, [])

  return { state: state.present, set, undo, redo, reset, canUndo, canRedo }
}
